import { render, staticRenderFns } from "./DeliveryCities.vue?vue&type=template&id=408c2f60&scoped=true&"
import script from "./DeliveryCities.vue?vue&type=script&lang=js&"
export * from "./DeliveryCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c2f60",
  null
  
)

export default component.exports